import { AlertSeverityEnum, IDataProducto, IEquipoServicioAdicionales } from '@/shared/interfaces';
import { toast } from 'react-toastify';
import { create } from 'zustand';
import { useSystemParamsStore } from '../administration';
import { SystemParametersEnum } from '@/shared';
import { useUiStore } from '@/store/ui';

interface EquiposAdicionales {
  open: boolean
  setOpen: (open: boolean) => void

  dataProducto: IDataProducto | null
  getProductoSlug: (data: { slug: string, cuotas: number, cantidad: number }) => void
  getDataProducto: (data: IEquipoServicioAdicionales | undefined) => void

  installmentAmount: number //valor de cada cuota
  ajusteCuota: number //ajuste de la cuota
  cuotas: number //cuotas
  cant: number

  isLoadingProducto: boolean

  totalPagar: number
  setTotalPagar: (totalPagar: number) => void

  setCant: (cant: number) => void
  setInstallments: (installments: number) => void

  productos: IEquipoServicioAdicionales[];
  setProductos: (productos: IEquipoServicioAdicionales[]) => void;
  handleEliminarProducto: (id: string) => void;
  handleEliminarProductoByKey: (key: keyof IEquipoServicioAdicionales,value:string,withChangeName?:boolean) => void
  handleAgregarProducto: (producto: IEquipoServicioAdicionales) => void;
  handleAgregarProductoNoRestriction: (producto: IEquipoServicioAdicionales) => void;
  handleActualizarProducto: (id: string, nuevosValores: Partial<IEquipoServicioAdicionales>) => void;
  handleActualizarProductoByKey: (key: keyof IEquipoServicioAdicionales, value: string, nuevosValores: Partial<IEquipoServicioAdicionales>) => void ;

  handleSetAllProductos: (productos: IEquipoServicioAdicionales[])=>void,
  handleClearAllProductos: () => void;
}


interface EquiposAdicionalesPreventa {
  slug: string;
  precio: number;
  precio_max: number;
  nombre: string;
  cuotas: number[];
  cantidad: number[];
  estado: boolean;
}

export const useEquiposAdicionales = create<EquiposAdicionales>((set, get) => ({
  productos: [],
  setProductos(productos) {
    set({ productos })
  },

  installmentAmount: 0,
  ajusteCuota: 0,
  cuotas: 0,
  setInstallments(installments) {
    set({ cuotas: installments })
  },
  cant: 0,
  setCant(cant) {
    set({ cant })
  },

  totalPagar: 0,
  setTotalPagar(totalPagar) {
    set({ totalPagar })
  },
  open: false,
  setOpen(open) {
    set({ open })
  },

  dataProducto: null,
  isLoadingProducto: false,
  async getProductoSlug({ slug, cantidad, cuotas }) {

    try {
      const systemParams = useSystemParamsStore.getState().systemParams
      const equiposAdicionales = systemParams.find(e => e.slug == SystemParametersEnum.EQUIPOS_ADICIONALES_PREVENTA)
      const array: EquiposAdicionalesPreventa[] = JSON.parse(equiposAdicionales?.valor!);
      const producto = array.find(e => e.slug == slug);

      if (producto) {
        let total = producto.precio * cantidad;

        if (slug == 'ROUTER_AC' && cuotas == 12) {
          total = producto.precio_max * cantidad;
        }

        set({ totalPagar: total })
        set({ installmentAmount: total / cuotas })
        set({ cuotas })
        set({ cant: cantidad })
        set({ open: true })
      } else {
        toast.info('Producto no encontrado en el inventario.')
      }
    } catch (error) {

      console.log(error);

    }

  },

  async getDataProducto(producto) {

    if (producto) {

      let cantidad = +producto.cantidad;
      let cuotas = +(!producto.cuotas || ( producto.cuotas && producto.cuotas as number <=1) ? 
      1 : (producto.cuotas as number));
      let precios = producto?.precios;
      let precioSeleccionado = precios?.at(0)?.precio;

      let total = +precioSeleccionado! * cantidad;

      if (cuotas >= 12) {
        precioSeleccionado = precios?.at(2)?.precio;
        total = +(precioSeleccionado??0) * cantidad;
      }
      console.log({
        total,
        cuotas,
        precioSeleccionado,
        cantidad,
        precios,
        producto,
        "ajusteCuota": (total-(((parseFloat((total/cuotas).toFixed(2)))*(cuotas-1)))).toFixed(2) 
      })

      set({ totalPagar: total })
      set({ installmentAmount: total / cuotas })
      set({ ajusteCuota: cuotas==1?
        0
        :parseFloat((total-(((parseFloat((total/cuotas).toFixed(2)))*(cuotas-1)))).toFixed(2))
      })
      set({ cuotas })
      set({ cant: cantidad })
      set({ open: true })
    } else {
      toast.info('Producto no encontrado en el inventario.')
    }

  },

  // Agregar un nuevo producto
  handleAgregarProducto: (producto) => {

    const setAlert = useUiStore.getState().setAlert;

    if (get().productos.some(element => element.codigo == producto.codigo))
      return setAlert(true, 'Inventariable previamente agregado.', AlertSeverityEnum.info)

    set((state) => {
      const productosActualizados = [...state.productos, producto];
      return {
        productos: productosActualizados
      };
    });
  },


  handleAgregarProductoNoRestriction: (producto) => {
    set((state) => {
      const productosActualizados = [...state.productos, producto];
      return {
        productos: productosActualizados
      };
    });
  },

  handleActualizarProducto(id, nuevosValores) {
    set((state) => {
      const productosActualizados = state.productos.map((producto) =>
        producto.id === id ? { ...producto, ...nuevosValores } : producto
      );
      return {
        productos: productosActualizados
      };
    });
  },

  handleActualizarProductoByKey(key, value, nuevosValores) {
    set((state) => {
      const productosActualizados = state.productos.map((producto) =>
        producto[key] === value ? { ...producto, ...nuevosValores } : producto
      );
      return {
        productos: productosActualizados
      };
    });
  },

  handleEliminarProducto(id) {
    set((state) => {
      const productosFiltrados = state.productos.filter((producto) => producto.id !== id);
      return {
        productos: productosFiltrados
      };
    });
  },
  handleEliminarProductoByKey(key,value,withChangeName=true) {
    set((state) => {
      const finded = state.productos.find((producto) => producto[key] === value);
      if(!finded){
        return {
          productos: state.productos
        };
      }
      const productosFiltrados = state.productos.filter((producto) => producto[key] !== value);
      if(!withChangeName){
        return {
          productos: productosFiltrados
        };
      }
      const arrayIds:string[]  = []

      const productosRenombrados = productosFiltrados.map(x=>{
        arrayIds.push(x.id!)
        return {
          ...x,
          descripcion: finded?.id==x?.id? 
            x?.descripcion?.replace(/#\d+/,`#${arrayIds?.filter(y=>y==x.id).length}`)
            :x?.descripcion,
        }
      });
      return {
        productos: productosRenombrados
      };
    });
  },
  handleSetAllProductos(state:IEquipoServicioAdicionales[]) {
    set(() => {
      return {
        productos: state
      };
    });
  },
  handleClearAllProductos() {
    set(() => {
      return {
        productos: []
      };
    });
  },

}));
